import { MobileDeviceUtils } from '../MobileDeviceUtils.ts';
import { StorageWrapper } from '../StorageWrapper.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
import { I18n } from '@colonist/i18n';
import { replaceLanguageInPath } from '../ClientI18n.ts';
import { ClientUserState } from '../ClientUserState.ts';
export function initDeviceLanguage() {
    var _ClientUserState_userState;
    const deviceLanguages = MobileDeviceUtils.getDeviceLanguages();
    if (deviceLanguages.length == 0) return;
    if (StorageWrapper.isLanguagePreferenceSelected()) return;
    if (((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.language) != undefined) return;
    const resolvedLanguage = resolveSupportedLanguage(deviceLanguages);
    if (StorageWrapper.getLanguage() != resolvedLanguage) StorageWrapper.setLanguage(resolvedLanguage);
    if (UIUtilsEjsVariables.language == resolvedLanguage) return;
    window.location.pathname = replaceLanguageInPath(window.location.pathname, resolvedLanguage);
}
function resolveSupportedLanguage(deviceLanguages) {
    for (const deviceLanguage of deviceLanguages){
        const resolved = resolveLanguageTag(deviceLanguage);
        if (resolved != undefined) return resolved;
    }
    return I18n.defaultLanguage;
}
function resolveLanguageTag(tag) {
    const normalizedTag = tag.toLowerCase();
    const exactMatch = I18n.languages.find((language)=>language.toLowerCase() == normalizedTag);
    if (exactMatch != undefined) return exactMatch;
    const subTags = normalizedTag.split('-');
    const baseLanguage = subTags[0];
    if (baseLanguage == 'pt') return subTags.includes('br') ? 'pt-BR' : 'pt-PT';
    if (baseLanguage == 'zh') return isChineseTraditional(subTags) ? 'zh-TW' : 'zh-CN';
    const fallbackBaseLanguage = I18n.languages.find((language)=>language.toLowerCase().split('-')[0] == baseLanguage);
    return fallbackBaseLanguage;
}
function isChineseTraditional(subtags) {
    const traditionalMarkers = [
        'hant',
        'tw',
        'hk',
        'mo'
    ];
    return subtags.some((subtag)=>traditionalMarkers.includes(subtag));
}
